import { Record } from 'immutable'

export interface IUserPermissions {
  readonly isAdmin: boolean
  readonly isBrokerageUser: boolean
  readonly isDevelopmentUser: boolean
  readonly isGuest: boolean
  readonly accessAllPipelines: boolean
  readonly editFeeDistribution: boolean
  readonly setFeaturedListing: boolean
  readonly specialPermissions: any
}

const UserPermissionsRecord = Record({
  accessAllPipelines: false,
  editFeeDistribution: false,
  isAdmin: false,
  isBrokerageUser: false,
  isDevelopmentUser: false,
  isGuest: false,
  setFeaturedListing: false,
  specialPermissions: {
    BrokeragePipeline_AccessAllPipelines: false,
    BrokeragePipeline_EditFeeDistribution: false,
    Listing_SetFeaturedListing: false,
  },
})

export class UserPermissions extends UserPermissionsRecord
  implements IUserPermissions {
  public static fromJS(
    initialState?: any,
    containsSpecialPermissions: boolean = false,
  ) {
    if (initialState) {
      const { specialPermissions, ...rest } = initialState
      return new UserPermissions({
        ...rest,
        specialPermissions: initialState,
      })
    } else {
      return new UserPermissions(initialState)
    }
  }

  public readonly accessAllPipelines: boolean
  public readonly editFeeDistribution: boolean
  public readonly isAdmin: boolean
  public readonly isBrokerageUser: boolean
  public readonly isDevelopmentUser: boolean
  public readonly isGuest: boolean
  public readonly setFeaturedListing: boolean
  public readonly specialPermissions: any

  constructor(props?: Partial<UserPermissions>) {
    props ? super(props) : super()
  }
}
